<template>
  <div class="datePickerDemo">
    <div class="head"></div>
    <div class="content">
      <div class="demo">
        <span class="format">年、月：</span>
        <span class="show" @click="showDatePicker(1, 2)">{{date1?date1:'请选择时间'}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      date1: '',
      time: [2018, 1, 1, 0, 0],
      minTime: [2018, 1, 1, 0, 0],
      maxTime: [],
      showChinese: false,
      resetTime: [],
      type: null
    }
  },
  props:['psMsg'],
  methods: {
    // 获取当前时间
    getCurTime (minTime) {
      var date
      if (minTime) {
        var newMinTime = []
        minTime.forEach((item, ind) => {
          if (ind < 3) {
            newMinTime.push(item)
          }
        })
        date = new Date(newMinTime.join('/'))
      } else {
        date = new Date()
      }

      var dafultTiemEnd = new Date(date)
      dafultTiemEnd.setDate(date.getDate() + 30)
      var y1 = dafultTiemEnd.getFullYear()
      var m1 = this.dealTimeFormat(dafultTiemEnd.getMonth() + 1)
      var d1 = this.dealTimeFormat(dafultTiemEnd.getDate())
      var h1 = date.getHours()
      var min1 = date.getMinutes()
      this.maxTime = [y1 * 1, m1 * 1, d1 * 1, h1 * 1, min1 * 1]
    },
    dealTimeFormat (data) {
      return data > 9 ? data : '0' + data
    },

    showDatePicker (demo, type) {
      var date = new Date()
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      var d = date.getDate()
      var h = date.getHours()
      var min = date.getMinutes()
      this.time = this.showChinese ? [y + '年', m + '月', d + '日', h + '时', min + '分'] : [y * 1, m * 1, d * 1, h * 1, min * 1]
      var dataObj = {}
      if (demo < 6) {
        dataObj = {
          type: type,
          showChinese: this.showChinese
        }
      }
      let init = JSON.parse(JSON.stringify(this.time))
      dataObj.value = init
      this.$datepicker(dataObj).then((e) => {
        var y = e[0]
        var m = e[1]
        var d = e[2]
        var h = e[3]
        var mm = e[4]
        if (demo === 1) {
          if(m<10){
            this.date1 = dataObj.showChinese ? y + m : y + '-0' + m
          }else{
            this.date1 = dataObj.showChinese ? y + m : y + '-' + m
          }
        this.$emit('transfer',this.date1)//将值绑定到transfer上传递过去
        }
      }).catch((e) => {
          // console.log(e)
        })
      }
  },
  mounted () {
    this.getCurTime()
  }
}
</script>
<style lang="less" scoped>
  .datePickerDemo {position: absolute;top:50%;right:.37rem;width: .42rem;height: .42rem;margin-top:-.21rem;background: url(../assets/icon_calendar.png) no-repeat center;background-size: 100% 100%;
    .content{width: .42rem;height: .42rem;opacity:0;}
    .demo {display: flex;justify-content: space-around;padding: 0 15px;border-bottom: 1px gray solid;
      span {flex-basis: 50%;font-size: 16px;line-height: 50px;}
      .format {text-align: left;}
      .show {text-align: right;}
    }
    .demo1 {padding: 0 15px;border-bottom: 1px gray solid;font-size: 16px;line-height: 50px;
      .format {text-align: left;}
      .show {text-align: right;}
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/datePickerDemo.vue